class CookieService {
    public getCookie(cookieName: string): string {
        let name = cookieName + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let cookieArray = decodedCookie.split(';');
    
        for(let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
    
        return "";
    }

    public setCookie(cookieName: string, cookieValue: string, expirationDays: number = 1): void {
        const date: Date = new Date();
        var encodedValue = encodeURIComponent(cookieValue);
        date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
        document.cookie = `${cookieName}=${encodedValue};expires=${date.toUTCString()};path=/`;
    }

    public deleteCookie(name: string) {
        var currentCookie = this.getCookie(name);

        if(currentCookie) {
            // set a date in the past
            let expiredDate: string = "Thu, 01 Jan 1970 00:00:01 GMT";
            document.cookie = `${name}=;expires=${expiredDate};path=/`;
        }
    }
}

export default new CookieService();
